export const urlRegex =
 //   /(http[s]?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/g;
    /((http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$)/g;

export const convertTextToUrl = (text:string) =>
    text.replace(urlRegex,  (url) => {
            const anchorLink = url.includes('http') ? url : `https://${url}`;
            return '<a href="' + anchorLink + '" target="_blank">' + url + '</a>'
        }
    );